import React from 'react';
import './NewsArticleSection.css';
import greenBullet from '../../assets/images/green-bullet.svg';
import { Link } from 'react-router-dom';

const NewsArticleSection = ({ article }) => {
  // If no article is provided, show a message
  if (!article) {
    return (
      <section className="news-article-section">
        <div className="container">
          <div className="article-not-found">
            <h2>Article not found</h2>
            <p>The article you're looking for doesn't exist or has been removed.</p>
            <Link to="/news" className="back-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.26129 11.3741L10.5494 6.99628C10.7102 6.83211 10.9246 6.75 11.139 6.75C11.3802 6.75 11.5946 6.83211 11.7554 6.99628C12.1039 7.32461 12.1039 7.89921 11.7554 8.22755L8.94135 11.1279H17.1424C17.6248 11.1279 18 11.5109 18 12.0034C18 12.4686 17.6248 12.879 17.1424 12.879H8.94135L11.7554 15.752C12.1039 16.0803 12.1039 16.6549 11.7554 16.9832C11.4338 17.3389 10.871 17.3389 10.5494 16.9832L6.26129 12.6054C5.91286 12.277 5.91286 11.7024 6.26129 11.3741Z" fill="currentColor"/>
              </svg>
              BACK TO NEWS
            </Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="news-article-section">
      <div className="container">
        <div className="article-header">
          <h1 className="article-title">{article.title}</h1>
          <div className="article-meta">
            <span className="article-date">{article.date}</span>
          </div>
        </div>

        <div className="article-content">
          {article.source && (
            <div className="article-source">
              <p>{article.source}</p>
            </div>
          )}
          
          {article.content.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>


        <div className="back-to-news">
          <Link to="/news" className="back-link">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.26129 11.3741L10.5494 6.99628C10.7102 6.83211 10.9246 6.75 11.139 6.75C11.3802 6.75 11.5946 6.83211 11.7554 6.99628C12.1039 7.32461 12.1039 7.89921 11.7554 8.22755L8.94135 11.1279H17.1424C17.6248 11.1279 18 11.5109 18 12.0034C18 12.4686 17.6248 12.879 17.1424 12.879H8.94135L11.7554 15.752C12.1039 16.0803 12.1039 16.6549 11.7554 16.9832C11.4338 17.3389 10.871 17.3389 10.5494 16.9832L6.26129 12.6054C5.91286 12.277 5.91286 11.7024 6.26129 11.3741Z" fill="currentColor"/>
            </svg>
            BACK TO NEWS
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NewsArticleSection;
